import FlashLib from "flashlib_onlyplay";
import Main from "./Main";

import ControllerReelsBackground from './slot/background';
import ControllerSlot from './slot/ControllerSlot';

import ReelsContainer from "./reels/ReelsContainer";
import ContainerBonusReels from "./reels/ContainerBonusReels";
import OverlayContainer from "Engine/containers/overlay/BaseOverlayContainer";

import Symbol from "./symbols/Symbol";
import BonusSymbol from "./symbols/BonusSymbol";

import StartScreenContainer from './startScreen/startScreen';
import InfoPopupContainer from "Engine/containers/InfoPopupContainer";

import PaytableContainer from "./paytable/PaytableContainer";
import PaytableContent from "./paytable/PaytableContent";
import PaytableControls from "./paytable/PaytableControls";

import SymbolAnimation from './symbols/SymbolAnimation';
import ControllerJackpotPanels from './jackpot/JackpotPanels/ControllerJackpotPanels';
import PopupWin from './popups/popupWin/PopupWin';
import BackgroundContainer from './background/BackgroundContainer';
import BackgroundContainerFront from './background/BackgroundContainerFront';

import ControllerReels from 'Engine/base/reels/ControllerReels';
import ControllerBonusReels from './reels/ControllerBonusReels';

import ControllerBonusUi from './ui/BonusGameUi';
import ControllerBonusGameStart from './popups/freespins/ControllerFreespinsStart';
import ControllerBonusGameEnd from './popups/freespins/ControllerFreespinsEnd';
import ControllerWinCollect from './popups/freespins/ControllerWinCollect';
import ControllerJackpotPanel from './jackpot/JackpotPanels/ControllerJackpotPanel';
import ControllerAntisipator from 'Engine/base/antisipators/ControllerAntisipators';
import BaseGameButton from './ui/BaseGameButton';
import ControllerCookieMan from './background/ControllerCookieMan';

FlashLib.registerClass('Button', BaseGameButton);

FlashLib.registerClass('Main', Main);

FlashLib.registerClass('ControllerSlot', ControllerSlot);
FlashLib.registerClass('ControllerReelsBackground', ControllerReelsBackground);

FlashLib.registerClass('ReelsContainer', ReelsContainer);
FlashLib.registerClass('ControllerReels', ControllerReels);

FlashLib.registerClass('ContainerBonusReels', ContainerBonusReels);
FlashLib.registerClass('ControllerBonusReels', ControllerBonusReels);

FlashLib.registerClass('Symbol', Symbol);
FlashLib.registerClass('BonusSymbol', BonusSymbol);

FlashLib.registerClass('StartScreenContainer', StartScreenContainer);

FlashLib.registerClass('InfoPopupContainer', InfoPopupContainer);

FlashLib.registerClass('OverlayContainer', OverlayContainer);

FlashLib.registerClass('PaytableContainer', PaytableContainer);
FlashLib.registerClass('PaytableContent', PaytableContent);
FlashLib.registerClass('PaytableControls', PaytableControls);
FlashLib.registerClass('SymbolAnimation', SymbolAnimation);
FlashLib.registerClass('ControllerJackpotPanels', ControllerJackpotPanels);
FlashLib.registerClass('PopupWin', PopupWin);
FlashLib.registerClass('BackgroundContainer', BackgroundContainer);
FlashLib.registerClass('BackgroundContainerFront', BackgroundContainerFront);
FlashLib.registerClass('ControllerBonusUi', ControllerBonusUi);
FlashLib.registerClass('ControllerBonusGameStart', ControllerBonusGameStart);
FlashLib.registerClass('ControllerBonusGameEnd', ControllerBonusGameEnd);
FlashLib.registerClass('ControllerWinCollect', ControllerWinCollect);
FlashLib.registerClass('ControllerJackpotPanel', ControllerJackpotPanel);
FlashLib.registerClass('ControllerAntisipator', ControllerAntisipator);
FlashLib.registerClass('ControllerCookieMan', ControllerCookieMan);
